import { StyledFormRowInputContainer, StyledLine, StyledRowDescription, StyledRowHeading, StyledRowTextContainer, StyledRowWrapper } from './form-row.styles';
import { FormRowProps } from './form-row.types';
export const FormRow = ({
  heading,
  description,
  children,
  showBottomLine = true,
  textSectionBody
}: FormRowProps) => <>
    <StyledRowWrapper data-sentry-element="StyledRowWrapper" data-sentry-source-file="form-row.tsx">
      <StyledRowTextContainer data-sentry-element="StyledRowTextContainer" data-sentry-source-file="form-row.tsx">
        <StyledRowHeading data-sentry-element="StyledRowHeading" data-sentry-source-file="form-row.tsx">{heading}</StyledRowHeading>
        <StyledRowDescription data-sentry-element="StyledRowDescription" data-sentry-source-file="form-row.tsx">{description}</StyledRowDescription>
        {textSectionBody}
      </StyledRowTextContainer>

      <StyledFormRowInputContainer data-sentry-element="StyledFormRowInputContainer" data-sentry-source-file="form-row.tsx">{children}</StyledFormRowInputContainer>
    </StyledRowWrapper>

    {showBottomLine && <StyledLine data-testid="form-row-bottom-line" />}
  </>;